var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('embed',{staticStyle:{"width":"100%","height":"calc(100vh - 76px)","margin-top":"76px","display":"block","overflow":"auto"},attrs:{"src":"https://gps.transplus.com"}})])
}]

export { render, staticRenderFns }